import { render, staticRenderFns } from "./CollectLog.vue?vue&type=template&id=70bf0e6e"
import script from "./CollectLog.vue?vue&type=script&lang=js"
export * from "./CollectLog.vue?vue&type=script&lang=js"
import style0 from "./CollectLog.vue?vue&type=style&index=0&id=70bf0e6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports